import "./BeyondWordsOverride.css";

import { ENABLE_ARTICLE_FIRSTFOLD } from "@helper/getEnvVariables";
import { useBeyondWordsPlayer } from "@hooks/useBeyondWords/useBeyondWordsPlayer";
import { useIsPlayerReady } from "@hooks/useBeyondWords/useIsPlayerReady";
import { useTooltipOnPlayerReady } from "@hooks/useBeyondWords/useTooltipOnBWPlayerReady";
import { BeyondWordsPlayerProps } from "@typings/BeyondWords.d";
import { twMerge } from "tailwind-merge";

import PlayerTooltip from "./PlayerTooltip";

const BeyondWordsPlayer = (props: BeyondWordsPlayerProps) => {
  const playerRef = useBeyondWordsPlayer(props);
  const playerReady = useIsPlayerReady(playerRef);
  const { showTooltip } = useTooltipOnPlayerReady(playerRef);

  const isArticleFirstFoldEnabled = ENABLE_ARTICLE_FIRSTFOLD;

  return (
    <div
      className={twMerge(
        "relative",
        isArticleFirstFoldEnabled ? "mb-0" : "mb-6",
      )}
    >
      {showTooltip && (
        <div className="absolute bottom-full left-0 mb-1 animate-fade-in">
          <PlayerTooltip />
        </div>
      )}
      <div className="flex flex-col gap-1 items-start w-full">
        <div className="w-full">
          <div
            ref={playerRef}
            id={`tts-inline-widget-${props.cueId}`}
            className={isArticleFirstFoldEnabled ? "tts-animate-on-play" : ""}
          />
        </div>
        {playerReady && isArticleFirstFoldEnabled && (
          <div className="w-full flex justify-end text-grey-700 text-4xs font-primary font-regular leading-[150%]">
            Generated by AI
          </div>
        )}
      </div>
    </div>
  );
};

export default BeyondWordsPlayer;
